export const plantedSpecies = (species) => {
  return species
    .filter(specie => !specie.end_date && specie.start_date);
};